import { render, staticRenderFns } from "./covert_face_list.vue?vue&type=template&id=7412b812"
import script from "./covert_face_list.vue?vue&type=script&lang=js"
export * from "./covert_face_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports